<script setup lang="ts">
import KParentTooltip from '@/components/tooltips/KParentTooltip.vue';

export interface Props {
  icon?: string;
  iconTitle?: string;
}
const props = withDefaults(defineProps<Props>(), {
  icon: 'mdi-alert-circle-outline',
  iconTitle: undefined,
});
</script>

<template>
  <div :class="$style.tableAlert" data-testid="tableAlert">
    <div :class="$style.iconItem">
      <KParentTooltip v-if="props.iconTitle" location="left" :offset="0">
        {{ props.iconTitle }}
      </KParentTooltip>
      <v-icon :icon="props.icon"></v-icon>
    </div>
    <div :class="$style.textItem">
      <slot>Warning</slot>
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.tableAlert {
  display: flex;
  align-items: center;
  line-height: 28px;
}

  .iconItem {
    color: colors.$color-yellow-500;
    font-size: 16px;
    padding-right: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .textItem {
    font-size: 18px;
  }
</style>
